/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import AppLayout from "../../../Components/Layout/Layout"
import { TopActions } from "../../../Components/TopActions/TopActions"
import { useNavigate } from "react-router-dom";
import LoadingPage from "../../../Components/Loading/Loading";
import Pagination from "../../../Components/Pagination/Pagination";
import { PaginationSd41s, Sd41s } from "../../../Dtos/Cadastros/Representantes/RepresentantesDtos";
import { CardView, Card, CardField, CardActions } from "../../../Components/CardView/CardView";
import styled from "styled-components";
import { Edit, Trash2 } from "lucide-react";
import { Table, TableContainer, Td, Th } from "../../../Components/Table/Table";
import { ConfirmeDialog } from "../../../Components/ConfirmeDialog/ConfirmeDialog";
import ApiService from "../../../Config/ApiConfig";

export const ListaRepresentantesPage = () => {
    const navigate = useNavigate()
    const [sd41s, setSd41s] = useState<Array<Sd41s>>([])
    const [filter, setFilter] = useState('');
    const [quantity, setQuantity] = useState('13');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        async function checkApi() {
            try {
                const apiService = new ApiService();

                const response = await apiService.get<boolean>("/auth/temAcesso", { params: { tarefa: "Representantes" } })

                if (!response) {
                    navigate("/home");
                }
            } catch (error) {
                navigate("/home");
            }
        }

        checkApi();
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        buscarRepresentantes()
    }, [currentPage, quantity, filter])

    const buscarRepresentantes = async () => {
        try {
            setLoading(true)

            const apiService = new ApiService();

            const sd41s = await apiService.get<PaginationSd41s>("/sd41Controller/listarRepresentantes", {
                params: {
                    currentPage,
                    qtd: quantity,
                    filter: filter
                }
            })

            const pages = Math.ceil(sd41s.count / Number(quantity));

            setSd41s(sd41s.values)
            setTotalPage(pages)

        } catch (error) {
        } finally {
            setLoading(false)
        }
    }

    const handleAddNew = () => { navigate("/representante") }
    const handleFiltrar = (filtro: string, qtd: string) => {
        setFilter(filtro);
        setQuantity(qtd);
    }
    const handleEdit = (id: number) => { navigate("/representante/" + id) };
    const handleDelete = async (id: number) => {
        try {
            setLoading(true)

            const apiService = new ApiService();
            await apiService.delete("/sd41Controller/excluirRepresentante", {
                params: {
                    'sd41id': id
                }
            })
            await buscarRepresentantes()
        } catch (error) {
        } finally {
            setLoading(false)
        }
    }

    const renderMobileView = () => (
        <CardView>
            {sd41s.map(sd01 => (
                <Card key={sd01.sd41id}>
                    <CardField>
                        <label>Codigo</label>
                        <span>{sd01.sd41codigo}</span>
                    </CardField>
                    <CardField>
                        <label>CNPJ</label>
                        <span>{sd01.sd41cnpj}</span>
                    </CardField>
                    <CardField>
                        <label>Nome</label>
                        <span>{sd01.sd41nome}</span>
                    </CardField>
                    <CardActions>
                        <ActionButton onClick={() => handleEdit(sd01.sd41id!)}>
                            <Edit size={16} />
                        </ActionButton>
                        <ActionButton className="delete" onClick={() => handleDelete(sd01.sd41id!)}>
                            <Trash2 size={16} />
                        </ActionButton>
                    </CardActions>
                </Card>
            ))}
        </CardView>
    );
    const renderDesktopView = () => (
        <TableContainer>
            <Table>
                <thead>
                    <tr>
                        <Th>#</Th>
                        <Th>Código</Th>
                        <Th>CNPJ</Th>
                        <Th>Nome</Th>
                        <Th>Telefone</Th>
                        <Th>Operações</Th>
                    </tr>
                </thead>
                <tbody>
                    {sd41s.map(sd41 => (
                        <tr key={sd41.sd41id}>
                            <Td>{sd41.sd41id}</Td>
                            <Td>{sd41.sd41codigo}</Td>
                            <Td>{sd41.sd41cnpj}</Td>
                            <Td>{sd41.sd41nome}</Td>
                            <Td>{sd41.sd41fone1}</Td>
                            <Td className="actions">
                                <ActionButton onClick={() => handleEdit(sd41.sd41id)}>
                                    <Edit size={16} />
                                </ActionButton>
                                <ConfirmeDialog
                                    message='Excluir usuario?'
                                    onCancel={() => { }}
                                    onConfirm={() => handleDelete(sd41.sd41id)}
                                    trigger={
                                        <ActionButton className="delete">
                                            <Trash2 size={16} />
                                        </ActionButton>
                                    }
                                />
                            </Td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </TableContainer>
    )

    if (loading) {
        return (
            <LoadingPage />
        )
    }
    return (
        <AppLayout>
            <TopActions
                filter={filter}
                quantity={quantity}
                handleAddNew={handleAddNew}
                filtrar={handleFiltrar}
            />

            {isMobile ? renderMobileView() : renderDesktopView()}

            <Pagination
                currentPage={currentPage}
                totalPages={totalPage}
                onPageChange={setCurrentPage}
            />
        </AppLayout>
    )
}

const ActionButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    color: #666;
    transition: color 0.2s;
  
    &:hover {
      color: ${props => props.className?.includes('delete') ? '#DC1E2D' : '#1e88e5'};
    }
  `;